angular
  .module('components.contact', [
    'ui.router'
  ]);
